import {Component, inject, input, output, signal, ViewChild} from '@angular/core';
import {EditorComponent} from "../../../../shared/components/editor/editor.component";
import {SaveCancelButtonsComponent} from "../../../admin/components/save-cancel-buttons/save-cancel-buttons.component";
import {ModalService} from "../../../../shared/data-access/modal.service";
import {NgIf} from "@angular/common";
import {AiService} from "../../../admin/data-access/ai.service";

@Component({
  selector: 'app-ai-editor',
  standalone: true,
  imports: [
    EditorComponent,
    NgIf,
  ],
  templateUrl: './ai-editor.component.html',
  styleUrl: './ai-editor.component.scss'
})
export class AiEditorComponent {
  protected readonly aiService = inject(AiService);
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  editorData = input<string>('')
  newEditorEvent = output<string>();
  content = signal<string>("");
  gptResponse = signal<string>("");

  onEditorEvent(event: string) {
    this.content.set(event);
    this.newEditorEvent.emit(event);
  }

  onGptResponse(response: string) {
    this.gptResponse.set(response);
  }

  acceptGptSolution() {
    this.editorComponent.editorInstance().setData(this.gptResponse());
    this.gptResponse.set("");
  }
}
